module.exports = __webpack_public_path__ + "img/idigi-claimnet.8ff5f79b.png";